<template>
  <div class="all">
    <div class="bommot">
      <!-- 侧边栏 -->
      <Ctar @clickFu="g_car_dynamic_data"></Ctar>
      <div class="back_ycjs_leftbg">
        <div style="width: 90%; height: 94%; margin-left: 4%; margin-top: 4%">
          <div style="width: 100%; height: 35%">
            <div class="title_bg_long">
              <div style="position: absolute; bottom: 65%; left: 2%">车辆参数</div>
            </div>
            <div style="margin-top: 1%; width: 100%; height: 90%; display: flex">
              <div style="width: 90%; height: 100%;">
                <!-- <div :class="model_1"></div> -->
                <!-- <img :src="img" alt style="width: 90%;height: 90%;margin-top: 3%" /> -->
                <img src="../../assets/img/wcar.png" alt style="width: 90%;height: 90%;margin-top: 3%" />
              </div>
              <div class="info">
                <P v-for="item in info" :key="item.value" :label="item.label" :value="item.value">{{ item.key }}: {{
                  item.value
                }}</P>
              </div>
            </div>
          </div>
          <div style="
              height: 0.3%;
              background-color: #00aaff;
              width: 100%;
              margin: 0 auto;
            "></div>
          <div style="width: 100%; height: 37%">
            <div style="width: 100%; height: 90%; display: flex; padding-top: 2%">
              <div style="width: 11%; height: 100%; color: #ffffff">
                <div style="font-size: 12px">{{ car_number }}</div>
              </div>
              <div style="
                  width: 10%;
                  height: 100%;
                  float: left;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-evenly;
                ">
                <div style="height: 20%; width: 100%">
                  <div class="near_lamp"></div>
                  <div style="color: #ffffff; font-size: 10px; margin-top: 5%">近光灯</div>
                </div>
                <div style="height: 20%; width: 100%">
                  <div class="alarm_lamp"></div>
                  <div style="
                      color: #ffffff;
                      font-size: 10px;
                      margin-top: 5%;
                      text-align: center;
                    ">报警灯</div>
                </div>
              </div>
              <div style="
                  width: 10%;
                  height: 100%;
                  float: left;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                ">
                <div style="height: 20%; width: 100%">
                  <div class="left"></div>
                  <div style="
                      color: #ffffff;
                      font-size: 10px;
                      margin-top: 5%;
                      text-align: center;
                    ">左转灯</div>
                </div>
                <div style="height: 20%; width: 100%">
                  <div class="center_lamp"></div>
                  <div style="
                      color: #ffffff;
                      font-size: 10px;
                      margin-top: 5%;
                      text-align: center;
                    ">中控锁</div>
                </div>
                <div style="height: 20%; width: 100%">
                  <div class="brake_lamp"></div>
                  <div style="
                      color: #ffffff;
                      font-size: 10px;
                      margin-top: 5%;
                      text-align: center;
                    ">刹车灯</div>
                </div>
              </div>
              <div style="width: 40%; height: 100%; float: left">
                <div class="model_2"></div>
              </div>
              <div style="
                  width: 10%;
                  height: 100%;
                  float: left;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                ">
                <div style="height: 20%; width: 100%">
                  <div class="right"></div>
                  <div style="
                      color: #ffffff;
                      font-size: 10px;
                      margin-top: 5%;
                      text-align: center;
                    ">右转灯</div>
                </div>
                <div style="height: 20%; width: 100%">
                  <div class="car_sxt"></div>
                  <div style="
                      color: #ffffff;
                      font-size: 10px;
                      margin-top: 5%;
                      text-align: center;
                    ">雾灯</div>
                </div>
                <div style="height: 20%; width: 100%">
                  <div class="R_lamp"></div>
                  <div style="
                      color: #ffffff;
                      font-size: 10px;
                      margin-top: 5%;
                      text-align: center;
                    ">倒车灯</div>
                </div>
              </div>
              <div style="
                  width: 10%;
                  height: 100%;
                  float: left;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-evenly;
                ">
                <div style="height: 20%; width: 100%">
                  <div class="far_lamp"></div>
                  <div style="
                      color: #ffffff;
                      font-size: 10px;
                      margin-top: 5%;
                      text-align: center;
                    ">远光灯</div>
                </div>
                <div style="height: 20%; width: 100%">
                  <div class="contour_light"></div>
                  <div style="
                      color: #ffffff;
                      font-size: 10px;
                      margin-top: 5%;
                      text-align: center;
                    ">轮廓灯</div>
                </div>
              </div>
            </div>
          </div>
          <div style="
              height: 0.3%;
              background-color: #00aaff;
              width: 100%;
              margin: 0 auto;
            "></div>
          <div style="width: 100%; height: 28%">
            <div style="height: 7%; width: 100%"></div>
            <div class="ybp_box">
              <div style="width: 80%; height: 80%; margin-top: 2%">
                <div style="width: 40%; height: 100%; float: left">
                  <div style="width: 100%; height: 100%" :id="tu"></div>
                </div>
                <div class="ybp_middle">
                  <div style="height: 35%; width: 100%">
                    <div style="height: 100%; width: 60%; margin: auto">
                      <img src="../../assets/img/ready.png" style="width: 100%; height: 80%" />
                    </div>
                  </div>
                  <div style="
                      height: 45%;
                      text-align: center;
                      font-size: 2rem;
                      color: #ffffff;
                    ">{{ car_info.gear }}</div>
                  <div style="
                      height: 20px;
                      width: 50px;
                      margin: auto;
                      line-height: 22px;
                      text-align: center;
                      font-size: 1rem;
                      color: #ffffff;
                      border: inset;
                      border-color: #dfdfdf;
                    ">{{ car_info.total_mileage }}</div>
                </div>
                <div style="width: 40%; height: 100%; float: left">
                  <div style="width: 100%; height: 100%" :id="tu2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 62%; height: 100%; float: left">
        <div class="map_box" style="
            display: flex;
            justify-content: center;
            align-content: center;
            padding-top: 0.5%;
          ">
          <div style="width: 99.3%; height: 99%" id="containerTwo">
            <div style="width: 100px; z-index: 999; position:absolute;">{{ vin }}</div>
          </div>
          <div style="
              width: 100%;
              height: 23%;
              position: absolute;
              z-index: 100;
              bottom: 1%;
              display: flex;
              justify-content: space-around;
            ">


            <div class="video_bg" v-if="show[0]" id="id_test_video1" @mousemove="move('id_test_video1')">
              <div v-show="vieotext.p1"
                style="position: absolute;bottom: 50px; left: -3px; width: 20px;z-index: 999; font-size: 14px;">前摄像
              </div>
            </div>


            <div class="video_bg" v-if="show[1]" id="id_test_video2" @mousemove="move('id_test_video2')">
              <div v-show="vieotext.p2"
                style="position: absolute;bottom: 50px; left: -3px; width: 20px;z-index: 999; font-size: 14px;">后摄像
              </div>
            </div>
            <div class="video_bg" v-if="show[2]" id="id_test_video3" @mousemove="move('id_test_video3')">
              <div v-show="vieotext.p3"
                style="position: absolute;bottom: 50px; left: -3px; width: 20px;z-index: 999; font-size: 14px;">左摄像
              </div>
            </div>
            <div class="video_bg" v-if="show[3]" id="id_test_video4" @mousemove="move('id_test_video4')">
              <div v-show="vieotext.p4"
                style="position: absolute;bottom: 50px; left: -3px; width: 20px;z-index: 999; font-size: 14px;">右摄像
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 4%"></div>
        <div class="ganzhi_box">
          <div style="width: 100%; height: 7%"></div>
          <div style="width: 100%; height: 93%; display: flex">
            <div style="
                width: 60%;
                height: 100%;
                display: flex;
                justify-content: space-around;
              ">
              <!-- <div style="width: 27%; height: 90%">
                <div class="title_bg_dt">电池信息</div>
                <div style="height: 5%"></div>
                <div
                  style="
                    width: 100%;
                    height: 80%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    font-size: 14px;
                  "
                >
                  <div
                    style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    "
                  >
                    <div style="width: 30%">剩余电量</div>
                    <div style="width: 20%">{{ car_info.dianchi }}</div>
                    <div class="dian_1"></div>
                  </div>
                  <div
                    style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    "
                  >
                    <div style="width: 30%">当前电流</div>
                    <div style="width: 20%">{{ car_info.dianliu }}</div>
                    <div class="dian_1"></div>
                  </div>
                  <div
                    style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    "
                  >
                    <div style="width: 30%">当前电压</div>
                    <div style="width: 20%">{{ car_info.dianya }}</div>
                    <div class="dian_1"></div>
                  </div>
                  <div
                    style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    "
                  >
                    <div style="width: 30%">电池状态</div>
                    <div style="width: 20%">{{ car_info.dianchi_status }}</div>
                    <div class="dian_1"></div>
                  </div>
                </div>
              </div>
              <div style="width: 27%; height: 90%">
                <div class="title_bg_dt">转向状态</div>
                <div style="height: 5%"></div>
                <div
                  style="
                    width: 100%;
                    height: 60%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    font-size: 14px;
                  "
                >
                  <div
                    style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    "
                  >
                    <div style="width: 30%">转向角度</div>
                    <div style="width: 20%">{{ car_info.jiaodu }}</div>
                    <div class="dian_1"></div>
                  </div>
                  <div
                    style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    "
                  >
                    <div style="width: 30%">EPS温度</div>
                    <div style="width: 20%">{{ car_info.eps }}</div>
                    <div class="dian_1"></div>
                  </div>
                  <div
                    style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    "
                  >
                    <div style="width: 30%">电机电流</div>
                    <div style="width: 20%">{{ car_info.dianjidianliu }}</div>
                    <div class="dian_1"></div>
                  </div>
                </div>
              </div>-->
              <div style="width: 40%; height: 90%">
                <div class="title_bg_dt">车辆行为监控</div>
                <div style="height: 5%"></div>
                <div style="            
                   width: 100%;
                    height: 90%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    font-size: 14px;">
                  <div style="height: 27%;   font-size: 14px;     height: 28px;
                        line-height: 28px; display: flex; ">
                    <div style="width: 50%;">
                      <span style="padding-left: 60px">系统状态</span>
                    </div>
                    <div :class="{ lvse: car_info.failure_details === '正常' }" style="width: 50%;text-align: center;">{{
                      car_info.failure_details
                    }}</div>
                  </div>
                  <div style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-evenly;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    ">
                    <div style="width: 20%">目标速度</div>
                    <div style="width: 20%;text-align: right;">{{ car_info.controller_target_speed }}</div>
                  </div>
                  <div style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-evenly;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    ">
                    <div style="width: 20%">刹车状态</div>
                    <div style="width: 20%;text-align: right;">{{ car_info.controller_is_brake }}</div>
                  </div>
                  <div style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-evenly;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    ">
                    <div style="width: 20%">目标角度</div>

                    <div style="width: 20%;text-align: right;">{{ car_info.controller_steering_angle }}</div>
                  </div>
                  <!-- <div style="height: 80%;display: flex;">
                    <div
                      style="width: 50%;font-size: 14px; display: flex;   flex-direction: column; justify-content: space-evenly;"
                    >
                      <div style="padding-left: 50px">目标速度</div>
                      <div style="padding-left: 50px">制动行程</div>
                      <div style="padding-left: 50px">转向角度</div>
                    </div>
                    <div
                      style="width: 50%;  display: flex;  font-size: 14px;  flex-direction: column; justify-content: space-evenly;"
                    >
                      <div style="padding-left: 50px">{{ car_info.VCU_target_speed }}</div>
                      <div style="padding-left: 50px">{{ car_info.vcu_brake_pro }}</div>
                      <div style="padding-left: 50px">{{ car_info.VCU_target_Angle }}</div>
                    </div>
                  </div>-->

                  <!-- <el-scrollbar>
                    <p
                      v-for="(item, index) in fault_info"
                      :key="index"
                      :class="bugcolor(item.bug_level)"
                      style="
                        border: 1px solid #9e9e9e;
                        height: 38px;
                        margin-top: 12px;
                        font-size: 14px;
                        line-height: 38px;
                      "
                    >
                      <span style="padding-left: 10px">[ {{ item.sender }} ]</span>
                      <span style="padding-left: 10px">{{ item.note }} {{ item.time }}</span>
                    </p>
                  </el-scrollbar>-->
                </div>
              </div>
              <div style="width: 40%; height: 90%">
                <div class="title_bg_dt">车辆状态</div>
                <div style="height: 5%"></div>
                <div style="
                    width: 100%;
                    height: 90%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    font-size: 14px;
                  ">
                  <div style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-evenly;
                      align-items: center;
                      color: rgb(255, 255, 255);
                    ">
                    <div style="width: 20%">电机扭矩</div>
                    <div style="width: 20%;text-align: right;" :class="color(car_info.motor_torque)">{{
                      car_info.motor_torque
                    }}</div>
                  </div>
                  <div style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: space-evenly;
                       align-items: center;
                      color: rgb(255, 255, 255);
                    ">
                    <div style="width: 20%">转向角度</div>
                    <div style="width: 20%;text-align: right;" :class="color(car_info.current_angle)">{{
                      car_info.current_angle
                    }}</div>
                  </div>
                  <div style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                                      justify-content: space-evenly;
                 align-items: center;
                      color: rgb(255, 255, 255);
                    ">
                    <div style="width: 20%">车辆速度</div>
                    <div style="width: 20%;text-align: right;" :class="color(car_info.car_speed)">{{
                      car_info.car_speed
                    }}</div>
                  </div>
                  <div style="
                      width: 100%;
                      height: 15%;
                      display: flex;
                                     justify-content: space-evenly;
                 align-items: center;
                      color: rgb(255, 255, 255);
                    ">
                    <div style="width: 20%">运行状态</div>
                    <div style="width: 20%;text-align: right;" :class="color(car_info.car_run_state)">{{
                      car_info.car_run_state
                    }}</div>
                  </div>
                </div>
              </div>
              <!-- <div style="width: 20%; height: 90%">
                <div class="title_bg_dt">车身状态</div>
                <div style="height: 5%"></div>
                <div
                  style="
                    width: 100%;
                    height: 80%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    font-size: 14px;
                  "
                >
                  <div class="shache">
                    <div style="width: 30%">近光灯</div>
                    <div class="deng_1"></div>
                  </div>
                  <div class="shache">
                    <div style="width: 30%">远光灯</div>
                    <div class="deng_1"></div>
                  </div>
                  <div class="shache">
                    <div style="width: 30%">左转灯</div>
                    <div class="deng_1"></div>
                  </div>
                  <div class="shache">
                    <div style="width: 30%">右转灯</div>
                    <div class="deng_1"></div>
                  </div>
                  <div class="shache">
                    <div style="width: 30%">雾灯</div>
                    <div class="deng_1"></div>
                  </div>
                  <div class="shache">
                    <div style="width: 30%">示廊灯</div>
                    <div class="deng_1"></div>
                  </div>
                  <div class="shache">
                    <div style="width: 30%">示警灯</div>
                    <div class="deng_1"></div>
                  </div>
                </div>
              </div>-->
            </div>
            <div style="width: 40%; height: 100%; float: left">
              <div style="width: 95%; height: 90%">
                <div class="ganzhi">车辆信息</div>
                <div style="height: 5%"></div>
                <div style="
                    width: 100%;
                    height: 91%;
                    display: flex;
                    justify-content: space-around;
                  ">
                  <div style="
                      width: 25%;
                      height: 93%;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                      color: rgb(255, 255, 255);
                    ">
                    <div class="gzzt_bg">
                      <p>当 前 电 量</p>
                      <p style="padding-top: 5px" :class="color(car_info.electricity)">{{ car_info.electricity }}</p>
                    </div>
                    <div class="gzzt_bg">
                      <p>当 前 电 流</p>
                      <p style="padding-top: 5px" :class="color(car_info.current_total_current)">{{
                        car_info.current_total_current
                      }}</p>
                    </div>
                    <div class="gzzt_bg">
                      <p>当 前 电 压</p>
                      <p style="padding-top: 5px" :class="color(car_info.current_total_voltage)">{{
                        car_info.current_total_voltage
                      }}</p>
                    </div>
                  </div>
                  <div class="car_tuo">
                    <div class="model_3">

                      <img src="../../assets/img/wcar.png" alt style="width: 100%;height: 100%;margin-top: 3%" />
                      <!-- <img :src="img" alt style="width: 100%;height: 100%;margin-top: 3%" /> -->
                    </div>
                  </div>

                  <div style="
                      width: 25%;
                      height: 90%;
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                      color: rgb(255, 255, 255);
                    ">
                    <div class="gzzt_bg">
                      <p>车 辆 模 式</p>
                      <p style="padding-top: 5px" :class="color(car_info.driving_mode)">{{ car_info.driving_mode }}</p>
                    </div>
                    <div class="gzzt_bg">
                      <p>急 停 状 态</p>
                      <p style="padding-top: 5px" :class="color(car_info.stop_state)">{{ car_info.stop_state }}</p>
                    </div>
                    <div class="gzzt_bg">
                      <p>远 程 状 态</p>
                      <p style="padding-top: 5px" :class="color('未接入')">
                        <!-- {{ car_info.Motor_status6 }} -->
                        未接入
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 1%; height: 100; float: left"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { reactive, onMounted, toRefs, ref, onBeforeUnmount } from "vue";
import AMap from "AMap";
import { get_car_list } from "../../api/car_info/api";
import Ctar from "../../components/ctar.vue";
import {
  get_car_base_info,
  get_car_dynamic_data,
  get_map_line,
  get_car_real_time_gps,
  get_car_video_flow,
} from "../../api/car_info/api";
let containerTwo = ""; //地图实例
let marker = ""; //标记
let polyline3 = "";
let polyline2 = "";
let time = ""; //计时器
let time2 = ""; //计时器
let time3 = ""; //计时器
let chartDomtu1 = ""; //echarts实例
let chartDomtu2 = ""; //echarts实例
let player1 = "1"; //视频实例
let player2 = "1"; //视频实例
let player3 = "1"; //视频实例
let player4 = "1"; //视频实例
let guiji = [];//轨迹
export default {
  name: "Drive",
  components: {
    Ctar
  },
  setup() {
    const tu = ref("chart" + Date.now() + Math.random());
    const tu2 = ref("chart2" + Date.now() + Math.random());
    const data = reactive({
      driving: "driving",
      drag: false,
      list: [1, 2, 3, 4, 5, 6],
      img: '',
      isCollapse: true,
      car_number: "",
      vin: "",
      vieotext: {
        p1: false,
        p2: false,
        p3: false,
        p4: false,
      },
      center: "",
      camera_video: [],
      sstt: ["ss1", "ss2", "ss3", "ss4"],
      info: [
        {
          key: "所属公司",
          value: "--"
        },
        {
          key: "车辆类型",
          value: "--"
        },
        {
          key: "电池容量",
          value: "--Kwh"
        },
        {
          key: "电机功率",
          value: "--Kw"
        },
        {
          key: "额定电压",
          value: "--V"
        }, {
          key: "最大速度",
          value: "--Km/h"
        },
      ],
      state: "未踩",
      line: [],
      show: [true, true, true, true],
      fault_info: "",
      car_info: {
        motor_torque: "",
        controller_steering_angle: "",
        car_speed: "",
        car_online_state: "",
        Motor_status: "",
        electricity: "--%",
        car_run_state: "",
        current_total_current: "--A",
        current_total_voltage: "--V",
        stop_state: "--",
        driving_mode: "--",
        gear: "",
        Motor_Speed: "",
        Motor_Speed5: "",
        speed: "",
        controller_target_speed: '',
        current_angle: '',
        controller_is_brake: '',
        failure_details: '',
        total_mileage: '',
        cishu: 1
      },
    });
    //销毁视频流
    const destory = () => {
      if (player1 != "1") {
        player1.destroy();
        player1 = "1";
      }
      if (player2 != "1") {
        player2.destroy();
        player2 = "1";
      }
      if (player3 != "1") {
        player3.destroy();
        player3 = "1";
      }
      if (player4 != "1") {
        player4.destroy();
        player4 = "1";
      }
    };
    //随意拖拽
    const move = (id) => {
      // 获取元素和初始值
      var oBox = document.getElementById(id), disX = 0, disY = 0;
      // 获取浏览器可见区域宽高，div宽高
      var browserWidth = document.documentElement.clientWidth,
        browserHeight = document.documentElement.clientHeight,
        boxWidth = document.getElementById(id).offsetWidth,
        boxHeight = document.getElementById(id).offsetHeight;
      // 容器鼠标按下事件
      oBox.onmousedown = function (e) {
        var e = e || window.event;
        // 鼠标相对于div左侧位置
        disX = e.clientX - this.offsetLeft;
        disY = e.clientY - this.offsetTop;
        document.onmousemove = function (e) {
          var e = e || window.event;
          oBox.style.left = (e.clientX - disX) + 'px';
          if ((e.clientX - disX) <= 0) {
            oBox.style.left = 0;
          } else if ((boxWidth - disX + e.clientX) >= browserWidth) {
            oBox.style.left = browserWidth - boxWidth + "px";
          }
          oBox.style.top = (e.clientY - disY) + 'px';
          if ((e.clientY - disY) <= 0) {
            oBox.style.top = 0;
          } else if ((boxHeight - disY + e.clientY) >= browserHeight) {
            oBox.style.top = browserHeight - boxHeight + "px";
          }
        };

        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
        return false;
      };
    }

    //视频流
    const g_car_video_flow = () => {
      get_car_video_flow(data.vin).then((res) => {
        destory();
        if (res.data) {
          for (let i in data.vieotext) {
            data.vieotext[i] = false
          }
          if (res.data[0].camera_video_1) {
            player1 = new TcPlayer("id_test_video1", {
              m3u8: res.data[0].camera_video_1,
              //  flv: res.data.camera_video_1, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
              autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
              poster: "http://www.test.com/myimage.jpg",
              controls: "none",
              width: "270", //视频的显示宽度，请尽量使用视频分辨率宽度
              height: "130", //视频的显示高度，请尽量使用视频分辨率高度
              volume: "0", //初始化音量
              wording: {
                1: "舜泰汽车",
                2: "车辆未推流",
              },
              listener: function (msg) {
                if (msg.type == 'load') {
                  data.vieotext.p1 = true
                }
              }
            });
          }
          if (res.data[0].camera_video_2) {
            player2 = new TcPlayer("id_test_video2", {
              m3u8: res.data[0].camera_video_2,
              // flv: res.data.camera_video_2, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
              autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
              poster: "http://www.test.com/myimage.jpg",
              controls: "none",
              width: "270", //视频的显示宽度，请尽量使用视频分辨率宽度
              height: "130", //视频的显示高度，请尽量使用视频分辨率高度
              volume: "0", //初始化音量
              wording: {
                1: "舜泰汽车",
                2: "车辆未推流",
              },
              listener: function (msg) {
                if (msg.type == 'load') {
                  data.vieotext.p2 = true
                }
              }
            });
          }
          if (res.data[0].camera_video_3) {
            player3 = new TcPlayer("id_test_video3", {
              m3u8: res.data[0].camera_video_3,
              //flv: res.data.camera_video_3, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
              autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
              poster: "http://www.test.com/myimage.jpg",
              controls: "none",
              width: "270", //视频的显示宽度，请尽量使用视频分辨率宽度
              height: "130", //视频的显示高度，请尽量使用视频分辨率高度
              volume: "0", //初始化音量
              wording: {
                1: "舜泰汽车",
                2: "车辆未推流",
              },
              listener: function (msg) {
                if (msg.type == 'load') {
                  data.vieotext.p3 = true
                }
              }
            });
          }
          if (res.data[0].camera_video_4) {
            player4 = new TcPlayer("id_test_video4", {
              m3u8: res.data[0].camera_video_4,
              //flv: res.data.camera_video_4, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
              autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
              poster: "http://www.test.com/myimage.jpg",
              controls: "none",
              width: "270", //视频的显示宽度，请尽量使用视频分辨率宽度
              height: "130", //视频的显示高度，请尽量使用视频分辨率高度
              volume: "0", //初始化音量\
              wording: {
                1: "舜泰汽车",
                2: "车辆未推流",
              },
              listener: function (msg) {
                if (msg.type == 'load') {
                  data.vieotext.p4 = true
                }
              }

            });
          }
        }
      });
    };
    //颜色
    const color = (name) => {
      if (name == "正常") {
        return "green";
      } else if (name == "故障" || name == "急停") {
        return "redcolor";
      } else {
        return "blue";
      }
    };

    //四个视频显示隐藏e
    const close = (id) => {
      data.show[id] = false;
    };
    //车辆基本信息
    const g_car_base_info = () => {
      get_car_base_info(data.vin).then((res) => {
        data.info = res.data;
        data.car_number = res.car_number;
        data.img = res.type_image
      });
    };


    //车辆轨迹
    const g_map_line = () => {
      get_map_line(data.vin).then((res) => {
        if (res.data.length != 0) {
          for (let i in res.data) {
            data.line = JSON.parse(res.data[i].points);
            let path = data.line.map((d) => {
              return new AMap.LngLat(d.lon, d.lat);
            });

            AMap.convertFrom(path, "gps", function (status, result) {
              if (result.info === "ok") {
                var path2 = result.locations;
                let polyline2 = new AMap.Polyline({
                  path: path2,
                  borderWeight: 2, // 线条宽度，默认为 1
                  strokeColor: "yellow", // 线条颜色
                  lineJoin: "round", // 折线拐点连接处样式
                });
                containerTwo.add(polyline2);
              }
            });
          }

        }

      });
    };
    //动态获取数据
    const g_car_dynamic = () => {
      get_car_dynamic_data(data.vin).then((res) => {
        if (res.car_online_state == 0) {
          for (let i in data.car_info) {
            data.car_info[i] = '未知'
          }
          data.car_info.gear = 'P'
          data.car_info.speed = 0
          data.car_info.Motor_Speed5 = 0
        } else {
          //电机扭矩
          data.car_info.motor_torque = res.data?.motor_torque?.data;
          if (data.car_info.motor_torque === undefined) {
            data.car_info.motor_torque = "未知";
          } else if (data.car_info.motor_torque == 0) {
            data.car_info.motor_torque = 0 + 'N·m'
          } else {
            data.car_info.motor_torque = Number(data.car_info.motor_torque).toFixed(1) + 'N·m'
          }
          //刹车状态
          data.car_info.controller_is_brake = res.data?.controller_is_brake?.data_name;
          if (data.car_info.controller_is_brake === undefined) {
            data.car_info.controller_is_brake = "未知";
          }
          //  累计里程
          data.car_info.total_mileage = res.data?.total_mileage?.data
          if (data.car_info.total_mileage === undefined) {
            data.car_info.total_mileage = "未知";
          } else {
            data.car_info.total_mileage =
              Number(data.car_info.total_mileage).toFixed(0);
            if (data.car_info.total_mileage <= 10000 && data.car_info.total_mileage > 1000) {
              data.car_info.total_mileage = '0' + data.car_info.total_mileage
            } else if (data.car_info.total_mileage <= 1000 && data.car_info.total_mileage > 100) {
              data.car_info.total_mileage = '00' + data.car_info.total_mileage
            } else if (data.car_info.total_mileage <= 100 && data.car_info.total_mileage > 10) {
              data.car_info.total_mileage = '000' + data.car_info.total_mileage
            } else if (data.car_info.total_mileage < 10) {
              data.car_info.total_mileage = '0000' + data.car_info.total_mileage
            } else {
              data.car_info.total_mileage = '00000'
            }
          }
          //目标角度
          data.car_info.controller_steering_angle = res.data?.controller_steering_angle?.data;
          if (data.car_info.controller_steering_angle === undefined) {
            data.car_info.controller_steering_angle = "未知";
          } if (data.car_info.controller_steering_angle == 0) {
            data.car_info.controller_steering_angle = 0 + "°";
          } else {
            data.car_info.controller_steering_angle = Math.abs(data.car_info.controller_steering_angle);
            data.car_info.controller_steering_angle = Number(data.car_info.controller_steering_angle).toFixed(1) + "°";
          }
          //转向角度
          data.car_info.current_angle = res.data?.current_angle?.data;
          if (data.car_info.current_angle === undefined) {
            data.car_info.current_angle = "未知";
          } else {
            data.car_info.current_angle =
              Number(data.car_info.current_angle).toFixed(0) + "°";
          }
          //目标速度
          data.car_info.controller_target_speed = res.data?.controller_target_speed?.data;
          if (data.car_info.controller_target_speed === undefined) {
            data.car_info.controller_target_speed = "未知";
          } else {


            data.car_info.controller_target_speed = Number(data.car_info.controller_target_speed).toFixed(0) + "Km/h";
          }
          //车辆速度
          data.car_info.car_speed = res.data?.car_speed?.data;
          if (data.car_info.car_speed === undefined) {
            data.car_info.car_speed = "未知";
            data.car_info.speed = "0";
          } else if (data.car_info.car_speed == 0) {
            data.car_info.speed = Number(data.car_info.car_speed).toFixed(1);
            data.car_info.car_speed = 0 + "Km/h";
          } else {
            data.car_info.speed = Number(data.car_info.car_speed).toFixed(1);
            data.car_info.car_speed = Number(data.car_info.car_speed).toFixed(1) + "Km/h";
          }


          //当前电量
          data.car_info.electricity = res.data?.electricity?.data
            ? Number(res.data.electricity.data).toFixed(0) + "%"
            : "未知";

          //当前电流
          data.car_info.current_total_current = res.data?.current_total_current?.data
            ? Math.abs(Number(res.data?.current_total_current?.data).toFixed(0)) + "A"
            : "未知";
          //当前电压
          data.car_info.current_total_voltage = res.data?.current_total_voltage?.data
            ? Number(res.data?.current_total_voltage?.data).toFixed(0) + "V"
            : "未知";
          //急停状态
          data.car_info.stop_state = res.data?.stop_state?.data_name;
          if (data.car_info.stop_state === undefined) {
            data.car_info.stop_state = "未知";
          }
          //车辆模式
          data.car_info.driving_mode = res.data?.driving_mode?.data_name;
          if (data.car_info.driving_mode == undefined) {
            data.car_info.driving_mode = "未知";
          }
          //车辆挡位 "0x01：电机反转（R档）；0x02：电机无转速（N档）；\n0x03：电机正转（D档）"
          data.car_info.gear = res.data?.gear?.data_name;
          if (data.car_info.gear == undefined) {
            data.car_info.gear = "X";
          }
          //驱动转速
          data.car_info.Motor_Speed = res.data?.motor_speed?.data || "0";
          data.car_info.Motor_Speed5 = res.data?.motor_speed?.data || "0";
          if (data.car_info.Motor_Speed != 0) {
            let num = data.car_info.Motor_Speed / 1000;
            data.car_info.Motor_Speed = Math.abs(Number(num.toFixed(1)));
            data.car_info.Motor_Speed5 = Math.abs(Number(data.car_info.Motor_Speed5));

          }
          //系统状态
          data.car_info.failure_details = res.data?.failure_details?.data_name;
          if (data.car_info.failure_details == undefined) {
            data.car_info.gear = "未知";
          } else if (data.car_info.failure_details == '') {
            data.car_info.failure_details = '正常'
          }
          //运行状态
          if (res.car_run_state == 0) {
            data.car_info.car_run_state = "正常";
          }
          else {
            data.car_info.car_run_state = "故障";
          }
        }

      });
    };

    //动态重载数据
    const g_car_dynamic_data = async (e) => {
      guiji = []
      if (e != undefined) {
        clearInterval(time3)
        containerTwo.clearMap();
        marker = ''
        localStorage.setItem("vin", e);

      }
      if (localStorage.getItem("vin") == null) {
        await get_car_list(data.vin).then((res) => {
          localStorage.setItem("vin", res.data[0].vin);
        });
      }
      data.cishu = 1
      data.vin = localStorage.getItem("vin");
      g_car_base_info();
      g_map_line();
      g_car_video_flow();
      time3 = setInterval(() => {
        g_car_dynamic();
        g_car_real_time_gps();
      }, 1000);
    };
    //获取gps
    const g_car_real_time_gps = () => {
      get_car_real_time_gps(data.vin).then((res) => {
        if (res.data.length != 0) {
          let lat = res.data[0].latitude;
          let lon = res.data[0].longitude;
          let course = res.data[0].course
          let cen = [lon, lat];
          if (lat != 0 && lon != 0) {
            AMap.convertFrom(cen, "gps", function (status, result) {
              // 创建一个 Icon
              var startIcon = new AMap.Icon({
                image:
                  "https://qlzxapi.suntaeiv.com/static/images/94fb15c9bff066c05b8be2e7322bb6b.png",
                // 图标所用图片大小
                imageSize: new AMap.Size(30, 50),
              });
              if (result.info === "ok") {
                if (res.data[0].online == 1) {
                  if (marker) {
                    marker.setAngle(course);
                    marker.setPosition([
                      result.locations[0].lng,
                      result.locations[0].lat,
                    ]);
                  } else {
                    marker = new AMap.Marker({
                      icon: startIcon,
                      position: [result.locations[0].lng, result.locations[0].lat],
                      offset: new AMap.Pixel(-13, -30),
                      angle: course,
                    });
                  }
                  marker.setMap(containerTwo);

                  if (data.cishu == 1) {
                    containerTwo.setZoomAndCenter(20, [
                      result.locations[0].lng,
                      result.locations[0].lat,
                    ]);
                    data.cishu++
                  }

                  let pahts = [
                    result.locations[0].lng,
                    result.locations[0].lat,
                  ]
                  guiji.push(pahts);
                  let dpaths = guiji.map((d) => {
                    return new AMap.LngLat(d[0], d[1]);
                  });
                  //判断 点的数量  进行 逻辑处理
                  if (polyline3) {
                    //判断清空上一次的轨迹
                    containerTwo.remove(polyline3);
                  }
                  polyline3 = new AMap.Polyline({
                    path: dpaths,
                    borderWeight: 2, // 线条宽度，默认为 1
                    strokeColor: "#3366FF", // 线条颜色
                    lineJoin: "round", // 折线拐点连接处样式
                  });
                  containerTwo.add(polyline3);
                } else {
                  if (marker) {
                  } else {
                    marker = new AMap.Marker({
                      icon: startIcon,
                      position: [result.locations[0].lng, result.locations[0].lat],
                      offset: new AMap.Pixel(-13, -30),
                      angle: course,
                    });
                    marker.setMap(containerTwo);
                    containerTwo.setZoomAndCenter(18, [
                      result.locations[0].lng,
                      result.locations[0].lat,
                    ]);
                  }
                }

              }
            });
          }


        }
        // else {
        //   containerTwo.setZoomAndCenter(18, [118.017482, 36.803601]);
        // }

      });
    };

    onMounted(() => {

      //高德地图
      containerTwo = new AMap.Map("containerTwo", {
        mapStyle: "amap://styles/blue", //设置地图的显示样式
        center: [118.017482, 36.803601],
        // mapStyle: "amap://styles/0988d61815064a32a4e2dd3d142d2e1c", 设置地图的显示样式
        zoom: 18,
      });

      // 汽车仪表盘echart
      chartDomtu1 = document.getElementById(tu.value);
      var myCharttu1 = echarts.init(chartDomtu1);
      let optiontu1 = {
        series: [
          {
            type: "gauge",
            radius: "95%",
            center: ["50%", "55%"],
            min: 0,
            max: 7,
            splitNumber: 7,
            progress: {
              show: true,
              width: 6,
            },
            axisLine: {
              lineStyle: {
                width: 8,
                color: [
                  [0.7, "#FFFFFF"],
                  [1, "#fd666d"],
                ],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              length: 3,
              lineStyle: {
                width: 1,
                color: "#999",
              },
            },
            axisLabel: {
              distance: 5,
              color: "#999",
              fontSize: 10,
            },
            anchor: {
              show: true,
              showAbove: true,
              size: 10,
              itemStyle: {
                borderWidth: 5,
              },
            },
            title: {
              color: "#fff",
              fontSize: 10,
              fontWeight: 800,
              fontFamily: "Arial",
              offsetCenter: [0, 20],
            },
            detail: {
              color: "#fff",
              valueAnimation: true,
              formatter: 0 + " r",
              fontSize: 15,
              offsetCenter: [0, "50%"],
            },
            data: [
              {
                value: 0,
                name: "1000r/min",
              },
            ],
          },
        ],
      };
      optiontu1 && myCharttu1.setOption(optiontu1);
      chartDomtu2 = document.getElementById(tu2.value);
      var myCharttu2 = echarts.init(chartDomtu2);
      let optiontu2 = {
        series: [
          {
            type: "gauge",
            radius: "95%",
            center: ["50%", "55%"],
            min: 0,
            max: 80,
            splitNumber: 8,
            progress: {
              show: true,
              width: 6,
            },
            axisLine: {
              lineStyle: {
                width: 8,
                color: [
                  [0.7, "#FFFFFF"],
                  [1, "#fd666d"],
                ],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              length: 3,
              lineStyle: {
                width: 1,
                color: "#999",
              },
            },
            axisLabel: {
              distance: 5,
              color: "#999",
              fontSize: 10,
            },
            anchor: {
              show: true,
              showAbove: true,
              size: 10,
              itemStyle: {
                borderWidth: 5,
              },
            },
            title: {
              color: "#fff",
              fontSize: 10,
              fontWeight: 800,
              fontFamily: "Arial",
              offsetCenter: [0, 20],
            },
            detail: {
              color: "#fff",
              valueAnimation: true,
              fontSize: 15,
              offsetCenter: [0, "50%"],
            },
            data: [
              {
                value: 0,
                name: "MPH",
              },
            ],
          },
        ],
      };
      optiontu2 && myCharttu2.setOption(optiontu2);
      time2 = setInterval(() => {
        myCharttu2.setOption({
          series: [
            {
              data: [
                {
                  value: data.car_info.speed,
                  name: "MPH",
                },
              ],
            },
          ],
        });
        myCharttu1.setOption({
          series: [
            {
              detail: {
                color: "#fff",
                valueAnimation: true,
                formatter: data.car_info.Motor_Speed5 + " r",
                fontSize: 15,
                offsetCenter: [0, "50%"],
              },
              data: [
                {
                  value: data.car_info.Motor_Speed,
                  name: "1000r/min",
                },
              ],
            },
          ],
        });
      }, 1000);
      //重载速度
      // time = setTimeout(() => {
      //   //初始化地图中心
      //   if (data.center) {
      //     AMap.convertFrom(data.center, "gps", function (status, result) {
      //       if (result.info === "ok") {
      //         containerTwo.setZoomAndCenter(18, [
      //           result.locations[0].lng,
      //           result.locations[0].lat,
      //         ]);
      //       }
      //     });
      //   }
      // }, 2000);
    });
    // g_car_dynamic_data();
    //离开页面之前销毁计时器和 地图
    // onBeforeUnmount(() => {
    //   //销毁地图
    //   containerTwo && containerTwo.destroy();
    //   //消除计时器
    //   clearInterval(time);
    //   clearInterval(time2);
    //   clearInterval(time3);
    // });
    return {
      ...toRefs(data),
      close,
      tu,
      tu2,
      g_car_base_info,
      g_car_dynamic_data,
      g_map_line,
      g_car_real_time_gps,
      color,
      move

    };
  },
};
</script>
<style lang="scss" scoped>
.all {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/img/back.png");
  background-size: 100% 100%;
  position: relative;
}

/deep/.vcp-player .marker {
  position: absolute;
  font-size: 16px;
  color: rgba(255, 255, 255, .5);
  bottom: 110px;
  text-align: center;

}

.redcolor {
  color: #f30000;
}

.yellow {
  color: #e7ff11;
}

.green {
  color: #88ff00bb;
}

.blue {
  color: rgb(0, 245, 245);
}

.lan {
  color: #00a4f3;
}

.back {
  background-image: url("../../assets/img/menu_ycjg_hover.png");
  width: 20px;
  height: 20px;
}

.bommot {
  width: 100%;
  height: 99%;
  position: absolute;
  z-index: 100;
  display: flex;
}

.back_ycjs_leftbg {
  width: 35%;
  height: 100%;
  float: left;
  background-image: url("../../assets/img/back_ycjs_leftbg.png");
  background-size: 100% 100%;
}

.title_bg_long {
  height: 7%;
  width: 100%;
  background-image: url("../../assets/img/title_bg_long.png");
  background-size: 100% 100%;
  color: #ffffff;
  position: relative;
}

.info {
  width: 35%;
  height: 97%;
  color: #ffffff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.info p {
  padding-top: 8px;
}

.left {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/left.png");
  background-size: 100% 100%;
}

.center_lamp {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/center_lamp.png");
  background-size: 100% 100%;
}

.near_lamp {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/near_lamp.png");
  background-size: 100% 100%;
}

.alarm_lamp {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/alarm_lamp.png");
  background-size: 100% 100%;
}

.brake_lamp {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/brake_lamp.png");
  background-size: 100% 100%;
}

.model_2 {
  width: 55%;
  height: 100%;
  margin: 0 auto;
  background-image: url("../../assets/img/model_2.png");
  background-size: 100% 100%;
}

.right {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/right.png");
  background-size: 100% 100%;
}

.far_lamp {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/far_lamp.png");
  background-size: 100% 100%;
}

.car_sxt {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/fog_lamp.png");
  background-size: 100% 100%;
}

.contour_light {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/contour_light.png");
  background-size: 100% 100%;
}

.R_lamp {
  height: 90%;
  width: 100%;
  background-image: url("../../assets/img/R_lamp.png");
  background-size: 100% 100%;
}

.ybp_box {
  height: 93%;
  width: 100%;
  background-image: url("../../assets/img/ybp_box.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
}

.ybp_middle {
  width: 20%;
  height: 90%;
  float: left;
  background-image: url("../../assets/img/ybp_middle.png");
  background-size: 100% 100%;
}

.ganzhi_box {
  width: 100%;
  height: 36%;
  background-image: url("../../assets/img/ganzhi_box.png");
  background-size: 100% 100%;
}

.map_box {
  width: 100%;
  height: 60%;
  background-image: url("../../assets/img/map_box.png");
  background-size: 100% 100%;
  position: relative;
}

/deep/.amap-copyright {
  font-size: 0px;
}

/deep/.amap-logo img {
  height: 0px !important;
  width: 0px !important;
}

#containerTwo {
  width: 100%;
  height: 100%;
}

.video_bg {
  width: 24%;
  height: 100%;
  // background-image: url("../../assets/img/video_bg.png");
  background-size: 100% 100%;
  text-align: right;
  position: relative;
}

.title_bg_dt {
  width: 100%;
  height: 15%;
  background-image: url("../../assets/img/title_bg_dt.png");
  background-size: 100% 100%;
  color: rgb(255, 255, 255);
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ganzhi {
  width: 30%;
  height: 15%;
  background-image: url("../../assets/img/title_bg_dt.png");
  background-size: 100% 100%;
  color: rgb(255, 255, 255);
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.dian_1 {
  background-image: url("../../assets/img/dian_1.png");
  background-size: 100% 100%;
  width: 15%;
  height: 70%;
}

.deng_1 {
  background-image: url("../../assets/img/deng_1.png");
  background-size: 100% 100%;
  width: 15%;
  height: 90%;
}

.shache {
  width: 100%;
  height: 15%;
  display: flex;
  align-items: center;
  color: rgb(255, 255, 255);
  justify-content: center;
}

.car_tuo {
  width: 45%;
  height: 90%;
  margin-top: 2%;
  background-image: url("../../assets/img/car_tuo.png");
  background-size: 100% 100%;
  position: relative;
}

.lvse {
  color: rgb(17, 228, 17);
}

.model_3 {
  width: 100%;
  height: 50%;
  //background-image: url("../../assets/img/model_1.png");
  background-size: 100% 100%;
  position: absolute;
  top: 10%;
}

.gzzt_bg {
  width: 100%;
  height: 31%;
  background-image: url("../../assets/img/gzzt_bg.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
</style>